import { render, staticRenderFns } from "./specific-case-details.vue?vue&type=template&id=c3a588ee&scoped=true&"
import script from "./specific-case-details.vue?vue&type=script&lang=tsx&"
export * from "./specific-case-details.vue?vue&type=script&lang=tsx&"
import style0 from "./specific-case-details.vue?vue&type=style&index=0&id=c3a588ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a588ee",
  null
  
)

export default component.exports